import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-20 pb-8" data-id="element-63">
      <div className="container mx-auto px-4" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16 text-center md:text-left" data-id="element-65">
          {/* Col 1: Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-66">
            <a href="#" className="flex items-baseline gap-1.5 mb-4" data-id="element-67">
              <span className="text-2xl font-serif font-bold text-white tracking-tight" data-id="element-68">
                Maid In
              </span>
              <span className="text-3xl font-script text-brand-gold" data-id="element-69">
                Heaven
              </span>
            </a>
            <p className="text-white/70 font-light mb-6 max-w-xs" data-id="element-70">
              Professional cleaning services that feel like a blessing.
            </p>
            <div className="flex items-center gap-4" data-id="element-71">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/80 hover:text-brand-gold hover:bg-white/10 transition-colors" data-id="element-72">
                <Facebook className="w-5 h-5" data-id="element-73" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/80 hover:text-brand-gold hover:bg-white/10 transition-colors" data-id="element-74">
                <Instagram className="w-5 h-5" data-id="element-75" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/80 hover:text-brand-gold hover:bg-white/10 transition-colors" data-id="element-76">
                <Twitter className="w-5 h-5" data-id="element-77" />
              </a>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-78">
            <h4 className="font-serif text-xl mb-6 text-brand-gold" data-id="element-79">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-80">
              {['Home', 'Services', 'About', 'Reviews', 'Book Online', 'Contact'].map(link => <li key={link} data-id="element-81">
                  <a href="#" className="text-white/70 hover:text-brand-gold transition-colors font-light" data-id="element-82">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Contact Info */}
          <div className="flex flex-col items-center md:items-start" data-id="element-83">
            <h4 className="font-serif text-xl mb-6 text-brand-gold" data-id="element-84">
              Contact Us
            </h4>
            <ul className="space-y-4 text-white/70 font-light text-center md:text-left" data-id="element-85">
              <li data-id="element-86">
                <a href="tel:+15551234567" className="hover:text-brand-gold transition-colors" data-id="element-87">
                  (555) 123-4567
                </a>
              </li>
              <li data-id="element-88">
                <a href="mailto:hello@maidinheaven.com" className="hover:text-brand-gold transition-colors" data-id="element-89">
                  hello@maidinheaven.com
                </a>
              </li>
              <li className="pt-2 text-sm text-white/50" data-id="element-90">
                Mon-Fri: 8am - 6pm
                <br data-id="element-91" />
                Sat: 9am - 2pm
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center" data-id="element-92">
          <p className="text-sm text-white/40 font-light" data-id="element-93">
            © 2025 Maid In Heaven Cleaning. All rights reserved. | Managed by
            LetLois
          </p>
        </div>
      </div>
    </footer>;
}